import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";
import { FormikErrors, FormikTouched } from "formik";
import React, { useEffect, useState } from "react";
import ClassifierModel from "../../core/api/ClassifierModel";

interface Props {
  value?: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  onBlur?: (event: React.FocusEvent<any>) => void;
  label?: string;
  className?: string;
  variant?: 'standard' | 'outlined' | 'filled';
  size?: 'small' | 'medium';
  name?: string;
  id?: string;
  error?: boolean;
  fullWidth?: boolean;
  labelId?: string;
  errors?: FormikErrors<any>;
  touched?: FormikTouched<any>;
  sx?: SxProps<Theme>;
}

function ClientStateSelectInput({
  value,
  onChange,
  onBlur,
  label = 'Kliento statusas',
  className,
  variant = 'outlined',
  size,
  name,
  id,
  error,
  fullWidth = true,
  labelId = 'client-state-label',
  errors,
  touched,
  sx
}: Props): React.ReactElement {
  const [userStates, setUserStates] = useState<ClassifierModel[]>([]);
  
  useEffect(() => {
    ClassifierModel.clientStates().then((s) => {
      setUserStates(s);
    });
  }, []);

  // Calculate error state based on provided props
  const hasError = error || (Boolean(errors?.clientState) && Boolean(touched?.clientState));

  return (
    <FormControl fullWidth={fullWidth} size={size} variant={variant} sx={sx}>
      <InputLabel id={labelId}>{label}</InputLabel>

      <Select
        labelId={labelId}
        value={value || ''}
        onChange={onChange}
        label={label}
        variant={variant}
        size={size}
        className={className}
        onBlur={onBlur}
        name={name}
        error={hasError}
        id={id}
      >
        <MenuItem value="">Nepasirinktas</MenuItem>
        {userStates.map((state) => (
          <MenuItem key={state.id} value={state.id}>
            {state.name}
          </MenuItem>
        ))}
      </Select>
      {errors?.clientState && touched?.clientState && (
        <FormHelperText error>
          {String(errors.clientState)}
        </FormHelperText>
      )}
    </FormControl>
  );
}

export default ClientStateSelectInput;
